<div
    class="notification-bell"
    [pTooltip]="'NOTIFICATION.BELL_TOOLTIP' | translate"
    tooltipPosition="bottom"
    (click)="notificationPopover.toggle($event)">
    <p-overlaybadge
        [value]="hasUnread() ? unreadCount().toString() : null"
        [severity]="hasUnread() ? 'danger' : 'success'">
        <i class="pi pi-bell"></i>
    </p-overlaybadge>

    <p-popover #notificationPopover appendTo="body" styleClass="notification-popover-panel">
        <div class="notification-popover">
            <div class="notification-popover__header">
                <h4>{{ 'NOTIFICATION.NOTIFICATIONS' | translate }}</h4>
            </div>

            <!-- New Notifications Section -->
            @if (hasUnread()) {
                <div class="notification-popover__section">
                    <span class="notification-popover__section-label">
                        {{ 'NOTIFICATION.NEW_NOTIFICATIONS' | translate }}
                    </span>
                    @for (item of unread(); track item.id) {
                        <div class="notification-item notification-item--unread" (click)="openNotification(item)">
                            <span class="notification-item__icon">{{ getTypeIcon(item.type) }}</span>
                            <div class="notification-item__content">
                                <span class="notification-item__title">{{ item.title }}</span>
                                @if (item.summary) {
                                    <span class="notification-item__summary">{{ item.summary }}</span>
                                }
                                <span class="notification-item__time">
                                    @if (item.version) { v{{ item.version }} · }
                                    {{ item.publishedAt | date:'d MMM' }}
                                </span>
                            </div>
                            <span class="notification-item__dot"></span>
                        </div>
                    }
                </div>
            }

            <!-- Previous Notifications Section -->
            <div class="notification-popover__section">
                <span class="notification-popover__section-label">
                    {{ 'NOTIFICATION.PREVIOUS' | translate }}
                </span>
                @if (validHistory().length === 0) {
                    <div class="notification-popover__empty">
                        {{ 'NOTIFICATION.NO_PREVIOUS' | translate }}
                    </div>
                } @else {
                    @for (item of validHistory(); track item.id) {
                        <div class="notification-item" (click)="openHistoryItem(item)">
                            <span class="notification-item__icon">{{ getTypeIcon(item.notification?.type) }}</span>
                            <div class="notification-item__content">
                                <span class="notification-item__title">{{ item.notification?.title }}</span>
                                @if (item.notification?.summary) {
                                    <span class="notification-item__summary">{{ item.notification?.summary }}</span>
                                }
                                <span class="notification-item__time">
                                    @if (item.notification?.version) { v{{ item.notification?.version }} · }
                                    {{ item.readAt | date:'d MMM' }}
                                </span>
                            </div>
                        </div>
                    }
                }
            </div>
        </div>
    </p-popover>
</div>
